<template>
  <el-drawer
    ref="drawer"
    :title="$t('Menu.LogInformation')"
    :visible="innerVisible"
    size="100%"
    custom-class="log-info-drawer"
    destroy-on-close
    append-to-body
    @close="handleClose"
  >
    <div style="display: flex;flex-direction:column;height: 100%">
      <div style="display: flex; flex-direction: row;justify-content: space-between;margin-bottom: 10px">
        <div>
          <el-select v-model="logType" style="margin-right: 5px" @change="logTypeChange">
            <el-option
              :label="$t('Message.Error2')"
              value="error"
            />
            <el-option
              :label="$t('Message.Warning')"
              value="warn"
            />
            <el-option
              :label="$t('Message.Info')"
              value="info"
            />
            <el-option
              :label="$t('SeaExport.Details')"
              value="details"
            />
          </el-select>
          <el-button type="danger" @click="clearLog">{{ $t('Menu.ClearLog') }}</el-button>
          <el-button type="primary" @click="uploadLog">{{ $t('Menu.UploadLog') }}</el-button></div>
        <div style="display: flex;width:300px;flex-direction: row;align-items: center">
          <span style="width: 170px">{{ $t('Menu.AuthorizationToken') }}</span><el-input readonly :value="$store.getters.token" />
        </div>
      </div>
      <div style="flex: 1">
        <el-table
          :data="logs"
          stripe
          size="mini"
          height="100%"
        >
          <el-table-column
            :label="$t('CargoMsg.Cargo_Date')"
            width="180"
          >
            <template slot-scope="scope">
              <i class="el-icon-time" />
              <span style="margin-left: 10px">{{ formatTime(scope.row.date) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('Menu.LogLevel')"
            width="100"
          >
            <template slot-scope="scope">
              {{ `[${ scope.row.type.toUpperCase() }]` }}
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('SeaExport.Details')"
          >
            <template slot-scope="scope">
              <p v-if="scope.row.type==='error'">{{ scope.row.error.stack|| scope.row.error }}</p>
              <p v-else>{{ scope.row.msg }}</p>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('Menu.Source')"
            width="180"
          >
            <template slot-scope="scope">
              <p v-if="scope.row.type==='error'">{{ scope.row.info }}</p>
              <p v-else>{{ scope.row.from }}</p>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </el-drawer>
</template>
<script>
import moment from 'moment'
export default {
  name: 'LogInfoDrawer',
  props: {
    visible: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      innerVisible: false,
      logType: 'error',
      logs: null
    }
  },
  watch: {
    visible(newVal, oldVal) {
      this.innerVisible = newVal
      if (newVal) {
        const { logs } = this.$store.getters
        this.logs = logs.filter(log => log.type === this.logType)
      }
    },
    innerVisible(newVal, oldVal) {
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false)
    },
    formatTime(time) {
      return moment(time).format('YYYY-MM-DD HH:mm:ss')
    },
    clearLog() {
      this.$store.dispatch('log/clearLog')
    },
    logTypeChange(val) {
      const { logs } = this.$store.getters
      this.logs = logs.filter(log => log.type === val)
    },
    uploadLog() {

    }
  }
}
</script>
<style lang="scss">
.log-info-drawer{
  font-size:16px;
  .el-drawer__header{
    margin-bottom: 10px;
  }
  .el-drawer__body{
    padding:15px;
  }
}
</style>
